import { withRouter } from 'react-router';
import { withUser } from 'components/queries/GetUserQuery';

import RedeemCompanionVouchersCta from './RedeemCompanionVouchersCta';

export default withRouter(withUser(RedeemCompanionVouchersCta));
